<template>
  <span>
    <v-btn small outlined color="primary" :disabled="disabled" @click="open = true">
      Duplicate load
    </v-btn>
    <v-dialog v-model="open" persistent max-width="580">
      <v-card>
        <v-card-title>Duplicate load {{ loadId }}?</v-card-title>
        <v-card-text>
          <p>This copies the last saved Load Status, Broker Information, Carrier/Asset Info,
            Stops and Income. Save any changes before duplicating.</p>
          <p>The copy gets its own Load ID and matching Reference #. You can edit it afterward.</p>
          <v-alert v-if="error" type="error" outlined dense>{{ error }}</v-alert>
          <v-alert v-if="created" type="success" outlined dense>
            Load {{ created.id }} was created.
            <router-link :to="{ name: 'edit load', params: { id: created.id } }">
              Open new load
            </router-link>
          </v-alert>
          <router-link v-if="uncertain" :to="{ name: 'loads' }">
            Check the load list before trying again
          </router-link>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text :disabled="busy" @click="open = false">
            {{ blocked ? 'Close' : 'Cancel' }}
          </v-btn>
          <v-btn color="primary" :loading="busy" :disabled="blocked" @click="duplicate">
            Create duplicate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { duplicateLoad, featureError } from '@/services/loadTools';

export default {
  name: 'DuplicateLoad',
  props: {
    loadId: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false, busy: false, error: '', created: null, uncertain: false,
    };
  },
  computed: {
    blocked() { return !!this.created || this.uncertain; },
  },
  methods: {
    async duplicate() {
      if (this.busy || this.blocked || this.disabled) return;
      this.busy = true;
      this.error = '';
      try {
        this.created = await duplicateLoad(this.loadId);
      } catch (error) {
        const status = error.response?.status;
        this.uncertain = !status || status >= 500;
        this.error = featureError(
          error,
          'The result could not be confirmed. Check the load list before creating another copy.',
        );
      } finally {
        this.busy = false;
      }
      if (this.created) {
        try {
          await this.$router.push({ name: 'edit load', params: { id: this.created.id } });
        } catch (error) {
          this.error = 'The copy was saved, but could not be opened. Use the link above.';
        }
      }
    },
  },
};
</script>
